import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceBoardCollectionsFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id' | 'idTags'>
);

export const WorkspaceBoardCollectionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceBoardCollections' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idTags' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceBoardCollectionsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceBoardCollectionsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceBoardCollectionsFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceBoardCollectionsFragment>,
    'data'
  > {
  data?: WorkspaceBoardCollectionsFragment;
}

export const useWorkspaceBoardCollectionsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceBoardCollectionsFragmentOptions): UseWorkspaceBoardCollectionsFragmentResult => {
  const result = Apollo.useFragment<WorkspaceBoardCollectionsFragment>({
    ...options,
    fragment: WorkspaceBoardCollectionsFragmentDoc,
    fragmentName: 'WorkspaceBoardCollections',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as WorkspaceBoardCollectionsFragment };
};
